import { render, staticRenderFns } from "./GestorDiligencias.vue?vue&type=template&id=8922ac3e"
import script from "./GestorDiligencias.vue?vue&type=script&setup=true&lang=js"
export * from "./GestorDiligencias.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports